import { Navigate } from "react-router-dom";

import { useAuth } from "contexts/AuthContext";
import { ROUTES } from "core/links";

const ProtectedRoute = ({ children }) => {
    const { status } = useAuth();

    if (status === "checking") {
        return null;
    }

    if (status !== "authenticated") {
        return <Navigate to={ROUTES.LOGIN} replace />;
    }

    return children;
};

export default ProtectedRoute;
